import { css } from '@emotion/css'
import { ToggleButton } from 'components/ToggleButton/ToggleButton'
import { translate } from 'i18n/i18n'
import type { TPrecipitationAggregation } from 'stores/detailsPanelStore/detailsPanelStore'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'

export const PrecipitationToggleButton = () => {
  const precipitationAggregation = detailsPanelStore.useSelector((s) => s?.precipitationAggregation)

  // we can define it here in case the type changes for TPrecipitationAggregation
  const dropDownData: { label: React.ReactNode; value: TPrecipitationAggregation }[] = [
    { label: translate.phrases.banyanApp('Hourly'), value: 'HOURLY' },
    { label: translate.phrases.banyanApp('Daily'), value: 'DAILY' },
  ]

  return (
    <ToggleButton
      buttonProps={{ size: 'xs', className: css({ fontSize: 13 }) }}
      data={dropDownData}
      onChange={(newValue) =>
        detailsPanelStore.setState((s) => ({ ...s, precipitationAggregation: newValue }))
      }
      value={precipitationAggregation}
    />
  )
}
